export class Admin {
  public id: number
  public name: string
  public email: string
  public phone: string
  public address: string
  public picture: string
  public updated: boolean
  public privilege: string

  constructor(admin:any = {}) {
    this.id = admin.id || null
    this.name = admin.name || ""
    this.email = admin.email || ""
    this.phone = admin.phone || ""
    this.picture = admin.picture || ""
    this.address = admin.address || ""
    this.updated = true
    this.privilege = admin.privilege || "editor"
  }
}



// WEBPACK FOOTER //
// ./src/_models/Admin.tsx